export enum EnumStatusIndicacao {
  pendente = 1,
  aprovado = 2,
  cancelado = 3,
}

export class StatusIndicacaoModel {
  public static status: StatusIndicacaoModel[] = [
    { codigo: EnumStatusIndicacao.pendente, descricao: "Pendente" },
    { codigo: EnumStatusIndicacao.aprovado, descricao: "Aprovado" },
    { codigo: EnumStatusIndicacao.cancelado, descricao: "Cancelado" },
  ];
  codigo: EnumStatusIndicacao;
  descricao: string;
}

export class ContatoIndicacao {
  nome: string;
  email: string;
  dataEnvio: Date;
  dataCadastro: Date;
  status: StatusIndicacaoModel;
}
